import React from 'react';

import SprintListItem from '../sprint/ListItem';
import BypassedListItem from '../bypassed/ListItem';
import QuickListItem from '../quick/ListItem';
import Box from 'common/Box';

export const SubscriptionList = ({
  sprintSubs,
  bypassedSubs,
  quickSubs,
  onSprintClick,
  onBypassedClick,
  onQuickClick,
  showSuspendedLabel = false,
}) => {
  if (!sprintSubs && !bypassedSubs) {
    return null;
  }

  return (
    <div>
      {sprintSubs.map(sub => (
        <Box key={sub.id}>
          <SprintListItem subscription={sub} onClick={onSprintClick} showSuspendedLabel={showSuspendedLabel} />
        </Box>
      ))}
      {bypassedSubs.map(sub => (
        <Box key={sub.id}>
          <BypassedListItem subscription={sub} onClick={onBypassedClick} showSuspendedLabel={showSuspendedLabel} />
        </Box>
      ))}
      {quickSubs.map(sub => (
        <Box key={sub.id}>
          <QuickListItem subscription={sub} onClick={onQuickClick} showSuspendedLabel={showSuspendedLabel} />
        </Box>
      ))}
    </div>
  )
}

export default SubscriptionList;
